export enum UserRoleEnum {
    Admin = "Admin",
    Employer = "Employer",
    Jobseeker = "Jobseeker",
    Viewer = "Viewer"
}